import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import type { ComponentProps, FC } from "react";

import { useChat } from "../../providers";

export interface ChatFormAbortButtonProps extends ComponentProps<typeof Button> {}

export const ChatFormAbortButton: FC<ChatFormAbortButtonProps> = (props) => {
  const { stop } = useChat();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="secondary" theme="primary" size="xs" display="icon" type="button" onClick={stop} {...props}>
          <Icon icon="stop" className="size-4 text-lg! filled" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Abort</TooltipContent>
    </Tooltip>
  );
};
